// Production Configuration
const prodConfig = {
  API_BASE_URL: 'https://solvix-inovasi.id/tabulara-api',

  // API Endpoints
  ENDPOINTS: {
    LOGIN: '/api/auth/login',
    LOGIN_FORM: '/api/auth/login-form',
    ME: '/api/auth/me',
    USERS: '/api/users',
    GROUPS: '/api/groups',
    GROUPS_WITH_USERS: '/api/groups/with-users',
    USER_GROUPS: '/api/user-groups',
    PAGES: '/api/pages',
    PAGE_PERMISSIONS: '/api/pages/group-permissions',
    MY_PAGES: '/api/pages/my-pages',
    UPLOAD_PDF: '/api/upload/pdf',
    UPLOAD_MULTIPLE: '/api/upload/multiple-pdf',
    SMART_PARSER: '/api/smart/process-files',
    RND_PROMPTING: '/api/rnd/process-with-prompt',
    FINANCIAL_ANALYSIS: '/financial-analysis/analyze-pdf',
    FINANCIAL_INSIGHTS: '/financial-analysis/financial-insights',
    AUDIT_PLAN_ANALYZE: '/api/audit-plan/analyze',
    AUDIT_PLAN_REPORT_TYPES: '/api/audit-plan/report-types',
    AI_ASSISTANT: '/api/assistant/chat',
    FINSIGHT_ANALYZE: '/api/finsight/analyze',
    FINSIGHT_HISTORY: '/api/finsight/history',
    SMART_FINSIGHT_ANALYZE: '/api/smart-finsight/analyze',
    SMART_FINSIGHT_HISTORY: '/api/smart-finsight/history',
    SMART_FINSIGHT_REPORT: '/api/smart-finsight/report',
    HEALTH: '/health'
  },

  // File Upload Settings
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB (for smart parser, audit plan, etc)
  MAX_FILE_SIZE_UPLOAD: 10 * 1024 * 1024, // 10MB (for basic upload)
  MAX_FILES: 20,
  ALLOWED_FILE_TYPES: ['.pdf', '.doc', '.docx', '.txt'],

  // Request Settings
  REQUEST_TIMEOUT: 300000, // 5 minutes
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second

  // UI Settings
  TOAST_DURATION: 3000, // 3 seconds
  DEBOUNCE_DELAY: 300, // 300ms

  // Feature Flags
  FEATURES: {
    BATCH_PROCESSING: true,
    FRAUD_DETECTION: true,
    AI_ASSISTANT: true,
    EXPORT_CSV: true,
    EXPORT_EXCEL: true
  }
};

export default prodConfig;

